/**
 * Selectors for loading states
 */

/**
 * Get all active loading states
 * @param {Object} state - Redux state
 * @returns {Object} Object of active loaders: { 'key1': true, 'key2': true }
 */
export const selectActiveLoaders = (state) => state?.loadingStates?.activeLoaders || {};

/**
 * Check if a specific key is loading
 * @param {string} key - Loading key to check
 * @returns {Function} Selector function
 */
export const selectIsLoading = (key) => (state) => {
    return Boolean(state?.loadingStates?.activeLoaders?.[key]);
};

/**
 * Check if any loading state is active
 * @param {Object} state - Redux state
 * @returns {boolean}
 */
export const selectIsAnyLoading = (state) => {
    const activeLoaders = state?.loadingStates?.activeLoaders || {};
    return Object.keys(activeLoaders).length > 0;
};
